import AdminClientList from "./Admin/AdminClientList";
import AgentClientList from "./Agent/AgentClientList";
import { isFieldAgent } from "../../utils/roleDetection";

const ClientList = () => {
	const stored = localStorage.getItem("loggedin_data");
	const user = stored ? JSON.parse(stored) : null;
	const roles = Array.isArray(user?.roles) ? user.roles : [];
	const isAgent = isFieldAgent(roles);

	return isAgent ? <AgentClientList /> : <AdminClientList />;
};

export default ClientList;
